// Small scripts to run on all pages through out the site

// Wrap each in a try so one thing breaking doesn't stop all JS
try {
  svg4everybody();
} catch (error) {
  console.error(error);
}

$(function() {
  require("./site-navigation");
  require("./header-search");
  require("./site-footer");
  require("./jump-links");
  require("./carousel");
  require("./search");
  require("./expandable");
  require("./factsheets");
  require("./expandable-pill");
  require("./data-tables");
});
